import React from "react";
import { Phone, Mail, MessageCircle, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

const supportOptions = [
  {
    title: "Help Center",
    description: "Browse our comprehensive knowledge base",
    icon: HelpCircle,
    action: "/help-center",
    dataTestId: "help-center",
  },
  {
    title: "Email Support",
    description: "Send us an email and we'll respond within 24 hours",
    icon: Mail,
    action: "mailto:support@memorycare.ai",
    dataTestId: "email-support",
  },
  {
    title: "Phone Support",
    description: "Call us directly for immediate assistance: +1 (650) 870-2370",
    icon: Phone,
    action: "tel:+16508702370",
    dataTestId: "phone-support",
  },
  {
    title: "Live Chat",
    description: "Chat with our support team in real-time",
    icon: MessageCircle,
    action: "#chat",
    dataTestId: "live-chat",
  },
];

export default function Support() {
  const handleSupportAction = (action: string) => {
    if (action.startsWith("tel:") || action.startsWith("mailto:")) {
      window.location.href = action;
    } else if (action.startsWith("/")) {
      // Handle internal navigation
      console.log("Navigating to:", action);
    } else if (action === "#chat") {
      // Handle chat initiation
      console.log("Opening chat");
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Support Center</h1>
        <p className="text-xl text-muted-foreground">
          We're here to help. Choose how you'd like to reach us.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {supportOptions.map((option) => (
          <Card 
            key={option.title}
            className="hover:shadow-lg transition-shadow duration-300"
            data-testid={option.dataTestId}
          >
            <CardHeader>
              <div className="flex items-center gap-4">
                <option.icon className="h-6 w-6 text-primary" />
                <CardTitle>{option.title}</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-base">
                {option.description}
              </CardDescription>
            </CardContent>
            <CardFooter>
              <Button 
                className="w-full"
                onClick={() => handleSupportAction(option.action)}
              >
                Contact Support
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
}